module.exports = __webpack_public_path__ + "img/grid-srp-preview-hyundai.6f189f2a.png";